import { render, staticRenderFns } from "./EmailSent.vue?vue&type=template&id=72759bc1&scoped=true&"
import script from "./EmailSent.vue?vue&type=script&lang=js&"
export * from "./EmailSent.vue?vue&type=script&lang=js&"
import style0 from "./EmailSent.vue?vue&type=style&index=0&id=72759bc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72759bc1",
  null
  
)

export default component.exports